import * as React from 'react';
const UserX = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-user-x", ...props },
    React.createElement("path", { d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
    React.createElement("circle", { cx: "8.5", cy: "7", r: "4" }),
    React.createElement("line", { x1: "18", y1: "8", x2: "23", y2: "13" }),
    React.createElement("line", { x1: "23", y1: "8", x2: "18", y2: "13" })));
export default UserX;
//# sourceMappingURL=UserX.js.map